<ng-container [formGroup]="form">
  <ng-select #countryDropDown
  id="country"
  formControlName="country"
  class="form-select"
  [ngClass]="{
    'is-invalid':
    (submitted || form.controls['country'].touched) && form.controls['country'].errors
  }"
  (change)="onOptionChange($event)"
  >
    <!-- <option selected [value]="null">India</option> -->
    <!-- <option *ngFor="let country of countries" [value]="country.code" [selected]="Selected_Country">{{ Send_Contry_Code }}</option> -->
     
    <!-- <ng-option *ngFor="let country of countries" [value]="country.name" [selected]="country.code === Send_Contry_Code">
      {{ country.name }}
    </ng-option> -->

    <ng-option *ngFor="let country of countries" [value]="country.name">
      {{ country.name }}
    </ng-option>

  </ng-select>
</ng-container>

